<template>
  <Drawer
    v-model="showDrawer"
    width="80"
    title="详情"
  >
    <div class="base-info">
      <!-- <div class="btn-main">
        <Button type="primary" @click="handleToEdit">编辑分账规则</Button>
      </div> -->
      <BaseDetailsInfo v-if="showDrawer" :config-id="configId" :create-time="createTime" :operate-time="operateTime" :operator-name="operatorName"></BaseDetailsInfo>
      <div class="tabs">
        <Tabs value="1" @on-click="onTabClick">
          <TabPane label="规则可见学校" name="1"></TabPane>
          <TabPane label="规则关联商品" name="2"> </TabPane>
          <TabPane
            v-if="providerType != 2"
            label="配置使用机构"
            name="3"
          ></TabPane>
        </Tabs>
      </div>
      <div v-show="tab == 2" class="search-wrap">
        <Form
          ref="searchForm"
          label-position="right"
          :label-width="100"
          class="search-list-430"
        >
          <Row>
            <FormItem label="商品名称/ID">
              <Input
                v-model="nameListValue"
                placeholder="请输入"
                clearable
                class="search-selectInput-430"
              >
                <Select
                  slot="prepend"
                  v-model="nameSelectValue"
                  placeholder="请选择名称/ID"
                  class="search-select-430"
                >
                  <Option
                    v-for="(item, index) in nameList"
                    :key="index"
                    :value="item.value"
                  >{{ item.label }}</Option>
                </Select></Input>
            </FormItem>
            <Button type="primary" @click="handleSearch">查询</Button>
          </Row>
        </Form>
      </div>
      <div class="table-wrap">
        <Table
          :columns="tabColumns"
          :data="tabTableList"
          :loading="loading"
          border
        >
          <template slot="acctName" slot-scope="{ row, index }">
            <span>{{ row.acctName || row.orgName }}</span>
          </template>
        </Table>
      </div>
      <div class="page-wrap">
        <Page
          :current="pageInfo.pageNum"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          show-total
          show-elevator
          @on-change="onPageChange"
        ></Page>
      </div>
    </div>
  </Drawer>
</template>
<script>
import { schColumns, commodityColumns1, commodityColumns2, orgColumns, nameList } from '../assets/data/details';
import BaseDetailsInfo from '../assets/components/BaseDetailsInfo.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    BaseDetailsInfo
  },
  data() {
    return {
      showDrawer: false,
      info: null,
      configId: '',
      itemType: '',
      providerType: '', //  1-校外机构 2-学校
      createTime: '',
      operateTime: '',
      operatorName: '',
      // tabTableList: [],
      tabTableSchList: [],
      tabTableCourseList: [],
      tabTableOrgList: [],
      type: 1,
      tab: 1,
      nameListValue: '',
      nameList,
      nameSelectValue: 'classroomName',
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false

    };
  },
  computed: {
    tabTableList() {
      let list = [];
      switch (Number(this.tab)) {
        case 1:
          list = this.tabTableSchList;
          break;
        case 2:
          list = this.tabTableCourseList;
          break;
        case 3:
          list = this.tabTableOrgList;
          break;
      }
      return list;
    },
    tabColumns() {
      let columns = [];
      switch (Number(this.tab)) {
        case 1:
          columns = schColumns;
          break;
        case 2:
          columns = this.itemType == 1 ? commodityColumns1 : commodityColumns2;
          break;
        case 3:
          columns = orgColumns;
          break;
      }
      return columns;
    }
  },
  methods: {
    openDrawer({ configId, itemType, providerType, createTime, operateTime, operatorName }) {
      this.configId = configId;
      this.itemType = itemType;
      this.providerType = providerType;//  1-校外机构 2-学校
      this.createTime = createTime;
      this.operateTime = operateTime;
      this.operatorName = operatorName;
      this.getTable();
      this.showDrawer = true;
    },
    getTable() {
      switch (Number(this.tab)) {
        case 1:
          this.getDivideConfigdSchoolPage();
          break;
        case 2:
          this.getListByDivideRuleId();
          break;
        case 3:
          this.getDivideConfigdOrgPage();
          break;
      }
    },

    getTabTableListParameter() {
      const parameter = {
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        configId: this.configId

      };
      return parameter;
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getTable();
    },
    // 获取规则可见学校
    async getDivideConfigdSchoolPage() {
      const parameter = this.getTabTableListParameter();
      this.loading = true;
      const res = await orderCenterApi.getDivideConfigdSchoolPage(parameter);
      this.loading = false;
      if (res.status == 200) {
        this.tabTableSchList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    // 获取主分账方范围
    async getDivideConfigdOrgPage() {
      const parameter = this.getTabTableListParameter();
      this.loading = true;
      const res = await orderCenterApi.getDivideConfigdOrgPage(parameter);
      this.loading = false;
      if (res.status == 200) {
        this.tabTableOrgList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    // 获取关联商品
    async getListByDivideRuleId() {
      if (this.nameSelectValue == 'classroomId' && this.nameListValue && !(/^[0-9]+.?[0-9]*$/.test(this.nameListValue))) {
        this.$Message.warning('商品ID查询只能输入数字');
        return null;
      }
      const parameter = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        classroomName: this.nameSelectValue == 'classroomName' ? this.nameListValue : '',
        classroomId: this.nameSelectValue == 'classroomId' ? this.nameListValue : ''
      };
      this.loading = true;
      let res;
      if (this.itemType == 1) {
        parameter.divideRuleId = this.configId;
        res = await orderCenterApi.getListByDivideRuleId(parameter);
      } else {
        parameter.divideConfigId = this.configId;
        res = await orderCenterApi.getCourseClassMaterialPage(parameter);
      }

      this.loading = false;
      if (res.status == 200) {
        this.tabTableCourseList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    handleToEdit() {
      this.showDrawer = false;
      this.$router.push({
        name: 'orderCenter_profitSharing_index_edit', query: {
          configId: this.configId,
          providerType: this.providerType
        }
      });
    },

    onTabClick(tab) {
      this.pageInfo.pageNum = 1;
      this.tab = tab;
      this.getTable();
      console.log(tab);
    },
    // 页码改变
    onPageChange(page) {
      this.pageInfo.pageNum = page;
      this.getTable();
    }

  }
};
</script>
<style lang="scss" scoped>
.head {
  background: rgb(247, 248, 250);
  line-height: 40px;
  font-weight: 700;
  padding: 0 20px;
  margin-bottom: 16px;
}
.btn-main {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
</style>
